import KValidationProvider from "./KValidationProvider";
import { VTextarea } from "vuetify/lib";

export default {
	name: "KTextarea",

	extends: KValidationProvider,

	props: {
		...VTextarea.options.props,

		color: {
			default: "link",
			type: String
		}
	},

	computed: {
		propsToPass() {
			const props = {};

			Object.keys( this.$props ).forEach( prop => {
				if ( prop in VTextarea.options.props ) {
					props[prop] = this.$props[prop];
				}
			} );

			return props;
		}
	},

	methods: {
		genValidatableField( props ) {
			return <VTextarea
				attrs={{
					...this.$attrs,
					...this.propsToPass,
					errorMessages: props.errors
				}}
				on={{ ...this.$listeners }}
				scopedSlots={this.$scopedSlots}
				vModel={this.internalValue}
			>
				{Object.keys( this.$slots ).map( slot =>
					<template slot={slot} key={slot}>{this.$slots[slot]}</template>
				)}
			</VTextarea>;
		}
	},

	render() {
		return this.genValidationProvider();
	}
};
